// extracted by css-extract-rspack-plugin
export default {"linkedPullRequestLink":"ConnectedEvent-module__linkedPullRequestLink__HzGQuW4"};